import type { $Fetch } from 'ofetch';
import type {
  TenantPagamentoConfig, UpsertTenantPagamentoConfigCommand,
} from '@/domain/model/TenantPagamentoConfig';
import type { TenantPagamentoConfigGateway } from '@/application/port/out/TenantPagamentoConfigGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';
import { DomainError } from '@/domain/error/DomainError';

const PATH = '/api/v1/commerce/pagamento-config';

export class HttpTenantPagamentoConfigGateway implements TenantPagamentoConfigGateway {
  constructor(private readonly client: $Fetch) {}

  async get(): Promise<TenantPagamentoConfig | null> {
    try {
      const res = await this.client<ApiResponse<TenantPagamentoConfig>>(PATH, { method: 'GET' });
      assertApiSuccess(res);
      return res.data;
    } catch (err) {
      // Backend retorna 404 (notFound) se tenant não tem config — UI cria via PUT
      if (err instanceof DomainError && err.status === 404) return null;
      throw err;
    }
  }

  async upsert(command: UpsertTenantPagamentoConfigCommand): Promise<TenantPagamentoConfig> {
    const res = await this.client<ApiResponse<TenantPagamentoConfig>>(PATH, { method: 'PUT', body: command });
    assertApiSuccess(res);
    return res.data;
  }
}
